<template>
  <div class="major-con">
    <div class="major-bg">
      高中课程学习与专业选择互适应系统
      <div class="child-sys">
        <div class="margin-left-20" :class="selectStatus == true ? 'selected' : ''">专业综合评价</div>
        <div class="margin-left-20" @click="dialogVisible=true">个性测评</div>
        <div class="margin-left-20" v-if="roles.includes('Aadmin') === true"  @click="goToFn('/adaptation')">子系统业务数据维护</div>
      </div>
    </div>
    <div class="back">
      <el-page-header class="back" @back="goBack" ></el-page-header>
    </div>
    <router-view></router-view>
    <el-dialog
      title="个性测评"
      :visible.sync="dialogVisible"
      width="50%">
      <div>
        <p>
          本测评可帮助你发现自身潜在的兴趣特点，更高效的进行职业规划、专业选择，甚至可以在日后的工作中找到自己最适合、最感兴趣的方向。
测试职业兴趣类型介绍
霍兰德在其一系列关于人格与职业兴趣关系的假设的基础上，提出了六种基本的职业兴趣类型，即：社会型(S)、企业型(E)、传统型(C)、实际型(R)、研究型(I)、艺术型(A)。

        </p>
        <div>
          <div v-for="(item, i) in typeList" :key="i"  class="flex">
            <div class="flex-left" :style="{'background': item.bg}">
              <div class="types" :style="{'color': item.color}">{{item.typeS}}</div>
              <div class="typen" :style="{'color': item.color}">{{item.typeN}}</div>
            </div>
            <div class="flex-right">{{item.desc}}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goToFn('/m-index/hld')">去 测 试</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      typeList: [{
        bg: '#e8f5fb',
        color: '#3884af',
        typeS: 'S',
        typeN: '社会型',
        desc: '喜欢与人交往、不断结交新的朋友、善言谈、愿意教导别人。关心社会问题、渴望发挥自己的社会作用。寻求广泛的人际关系，比较看重社会义务和社会道德。'
      }, {
        bg: '#faeff5',
        color: '#db3878',
        typeS: 'E',
        typeN: '企业型',
        desc: '追求权力、权威和物质财富，具有领导才能。喜欢竞争、敢冒风险、有野心、抱负。为人务实，习惯以利益得失，权利、地位、金钱等来衡量做事的价值，做事有较强的目的性。'
      }, {
        bg: '#e8faeb',
        color: '#3b8575',
        typeS: 'C',
        typeN: '传统型',
        desc: '喜欢与人交往、不断结交新的朋友、善言谈、愿意教导别人。关心社会问题、渴望发挥自己的社会作用。寻求广泛的人际关系，比较看重社会义务和社会道德。'
      }, {
        bg: '#fdf8db',
        color: '#cc5e2d',
        typeS: 'R',
        typeN: '实际型',
        desc: '愿意使用工具从事操作性工作，动手能力强，做事手脚灵活，动作协调。偏好于具体任务，不善言辞，做事保守，较为谦虚。缺乏社交能力，通常喜欢独立做事。'
      }, {
        bg: '#fbedfb',
        color: '#b632b9',
        typeS: 'I',
        typeN: '研究型',
        desc: '思想家而非实干家，抽象思维能力强，求知欲强，肯动脑，善思考，不愿动手。喜欢独立的和富有创造性的工作。知识渊博，有学识才能，不善于领导他人。考虑问题理性，做事喜欢精确，喜欢逻辑分析和推理，不断探讨未知的领域。'
      }, {
        bg: '#f0f2fc',
        color: '#3f2df8',
        typeS: 'A',
        typeN: '艺术型',
        desc: '有创造力，乐于创造新颖、与众不同的成果，渴望表现自己的个性，实现自身的价值。做事理想化，追求完美，不重实际。具有一定的艺术才能和个性。善于表达、怀旧、心态较为复杂。'
      }]
    }
  },
  computed: {
    username() {
      console.log(this.$store.getters.name);
      return this.$store.getters.name;
    },
    roles() {
      return this.$store.getters.roles;
    },
    selectStatus () {
      console.log('this.$route', this.$route)
      if (this.$route.meta.title === 'adaptation') {
        return true
      }
      return  false
    }
  },
  methods: {
    goToFn(url) {
      if (url.indexOf("hld") > -1 && this.$store.getters.roles.length === 0) {
        this.$router.push({path: "/login",
          query: {
            href: '/m-index/hld'
          }
        });
      } 
      this.$router.push(url);
    },
    goBack() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="less">
.major-con {
  .back {
    max-width: 100%;
    margin: 20px auto 0;
    padding: 0 0 0 80px;
  }
}
.major-bg {
  width: 100%;
  height: 230px;
  line-height: 150px;
  text-align: center;
  color: #fff;
  font-size: 50px;
  font-weight: bold;
  letter-spacing: 15px;
  background-image: url('../../../assets/img/major-bg.jpeg');
  position: relative;
  .child-sys {
    position: absolute;
    justify-content: center;
    bottom: 20px;
    left: 0;
    width: 100vw;
    height: 50px;
    font-size: 24px;
    display: flex;
    align-items: center;
    >div {
      cursor: pointer;
      color: #fff;
      height: 50px;
      line-height: 50px;
      position: relative;
      border: 1px solid #fff;
      border-radius: 10px;
      padding-left: 15px;
      &::after {
        width: 1px;
        height: 10px;
        background: #fff;
        position: absolute;
        right: 0;
        top: 10px;
      }
    }
    .margin-left-20 + .margin-left-20 {
      margin-left: 20px;
    }
    // .margin-left-20
    .selected {
      background: #fff;
      color: #0b56b0;
      text-align: center;
      border-radius: 10px;
      border: none;
    }
  }
}
p {
  margin-bottom: 30px;
  text-indent: 30px;
}
.flex {
  display: flex;
  align-items: center;
  .flex-left {
    flex-shrink:0;
    width: 60px;
    height: 50px;
    border-radius: 5px;
    text-align: center;
    padding-top: 10px;
    margin-right: 20px;
    .types {
      font-size: 16px;
      font-weight: bold;
    }
    .typen {
      font-size: 12px;
    }
  }
}
.flex  + .flex  {
  margin-top: 20px;
}
</style>

